/**
 *
 * Deckable
 *
 * Choose your own adventure for creating deck interfaces
 */
const $         = require('jQuery');
const _model    = require( './_model.js' );


var Deckable = function(el, options){

    this.$el                = $(el);
    this.$deckContainer     = this.$el.find( '.deckable__container' );
    this.$decks             = this.$el.find( '.deckable__slide' );
    this.$loading           = this.$el.find( '.deckable__loading' );
    this.$initialDeck       = null;
    this.$active            = null;


    this.defaults = {

        activeClass         : 'is-active',
        deactiveClass       : 'slideOutRight',
        defaultAnimation    : 'slideInRight',
        firstDeckAttr       : null,
        firstDeckClass      : 'deckable__first',
        defaultActiveClass  : 'is-default' //classname of default active element
    };

    this.settings = $.extend( {}, this.defaults, (typeof options === "object" ? options : {} ) );
    this.hasDeactive        =  _model.empty( this.settings.deactiveClass );

    this.init();
};

Deckable.prototype.init = function(){

    // get active
    this.$active        = this.getActiveDeck();
    this.$initialDeck   = this.$el.find( `[data-deck='${this.settings.initialDeckAttr}']` );

    if( this.settings.firstDeckAttr || (this.$active.length === 0 && this.$initialDeck.length !== 0) ){

        this.$initialDeck.addClass( `${this.settings.activeClass} ${this.settings.firstDeckClass}` );
        //check for setting first slide
    }

    function whichTransitionEvent(){
        var t,
            el = document.createElement("fakeelement");

        var transitions = {
            "transition"      : "transitionend",
            "OTransition"     : "oTransitionEnd",
            "MozTransition"   : "transitionend",
            "WebkitTransition": "webkitTransitionEnd"
        };

        for (t in transitions){
            if (el.style[t] !== undefined){
                return transitions[t];
            }
        }
    }

    this.$decks
        .on( 'focus', (event)=>event.preventDefault() );

};

Deckable.prototype.getActiveDeck = function(){

    return this.$decks.filter( $( `.${this.settings.activeClass}` ) );

};

Deckable.prototype.getActiveDeckAttr = function(){

    return this.$active;

};

Deckable.prototype.goToDeck = function( deckAttr ){

    let targetDeck = this.$deckContainer.find( `[data-deck='${deckAttr}']` );

    try {
        //if the active class has the target class, then return
        if( this.$active === deckAttr || targetDeck.length === 0 ){
            return false;
        }

        if( this.hasDeactive ){

            this.$active
                .itblAnimate( '', this.settings.deactiveClass );

        }

        this.hideAllDecks();
        $(targetDeck)
            .addClass( `${this.settings.activeClass} ${this.settings.defaultAnimation}`  );

        this.$active = deckAttr;

    }catch (e) {

        console.log( `Error finding deck-${deckAttr}` );
    }


};

Deckable.prototype.hideAllDecks = function(){

    this.$decks.removeClass( `${this.settings.activeClass} ${this.settings.defaultAnimation} ${this.settings.defaultActiveClass} ${this.settings.firstDeckClass}` );
    //unset the focus of any elements selected
    document.activeElement.blur();
};


Deckable.prototype.setFocus = function( ){

    try{
        const targetDeck = this.getActiveDeck();
        const getActiveEls = targetDeck.find( 'a, button, :input, [tabindex], select' );

        if( getActiveEls.length ){
            $( getActiveEls[0] ).focus();
        }else{
            window.focus();
        }
    }catch (e) {
        console.log( e );
    }


};

module.exports = Deckable;
